import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChatOpen", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { CianNewbuildingChatButtonContext } from './CianNewbuildingChatButtonContext';
import { ContactListModal } from './parts';
import { getNewbuildingChatContacts } from './utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Кнопка открытия чата по сущности ЖК. В случае многих контактов открывает модалку.
 */
export var CianNewbuildingChatButton = /*#__PURE__*/React.memo(function (_ref) {
  var onChatOpen = _ref.onChatOpen,
    onClick = _ref.onClick,
    restButtonProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(CianNewbuildingChatButtonContext),
    builders = _React$useContext.builders,
    sellers = _React$useContext.sellers;
  var chatContacts = getNewbuildingChatContacts(builders, sellers);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isModalOpen = _React$useState2[0],
    setIsModalOpen = _React$useState2[1];
  var handleButtonClick = function handleButtonClick(event) {
    onClick === null || onClick === void 0 || onClick(event);
    if (chatContacts.length === 1) {
      onChatOpen(chatContacts[0]);
    } else {
      setIsModalOpen(true);
    }
  };
  if (chatContacts.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isModalOpen && /*#__PURE__*/_jsx(ContactListModal, {
      onChatOpen: onChatOpen,
      onClose: function onClose() {
        return setIsModalOpen(false);
      }
    }), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, restButtonProps), {}, {
      onClick: handleButtonClick
    }))]
  });
});
CianNewbuildingChatButton.displayName = 'CianNewbuildingChatButton';